import { formatARS } from "./api";

export function buildComanda({ settings, order, number, subtotal, fee }) {
  const L = [];
  L.push(`🍕 *NUEVO PEDIDO #${number}* — ${settings.business_name}`);
  L.push("━━━━━━━━━━━━━━━");
  L.push(`👤 *Cliente:* ${order.customer_name}`);
  L.push(`📱 *Teléfono:* ${order.customer_phone}`);
  L.push("");
  L.push("🧾 *DETALLE*");
  order.items.forEach((it) => {
    L.push(`▪️ ${it.qty}x ${it.name} — ${formatARS(it.unit_price * it.qty)}`);
    (it.details || []).forEach((d) => L.push(`    ↳ ${d}`));
  });
  if (order.notes) {
    L.push("");
    L.push(`📝 *Notas:* ${order.notes}`);
  }
  L.push("");
  if (order.delivery_type === "delivery") {
    const d = order.delivery;
    L.push("🛵 *ENTREGA: DELIVERY*");
    L.push(`📍 ${d.address} ${d.number}`);
    L.push(`↔️ Entre: ${d.between}`);
    L.push(`🔎 Ref: ${d.reference}`);
  } else {
    L.push("🏪 *ENTREGA: RETIRO EN LOCAL*");
  }
  L.push("");
  L.push(`Subtotal: ${formatARS(subtotal)}`);
  if (fee > 0) L.push(`Envío: ${formatARS(fee)}`);
  L.push(`💰 *TOTAL: ${formatARS(order.total)}*`);
  L.push("");
  if (order.payment_method === "efectivo") {
    L.push("💵 *Pago:* Efectivo");
    if (order.cash_amount) {
      L.push(`Abona con: ${formatARS(order.cash_amount)}`);
      L.push(`Vuelto: ${formatARS(Math.max(0, order.cash_amount - order.total))}`);
    }
  } else {
    L.push("🏦 *Pago:* Transferencia");
    L.push("📎 Adjunto la foto del comprobante a continuación.");
  }
  L.push("━━━━━━━━━━━━━━━");
  return L.join("\n");
}

export function waLink(phone, text) {
  const digits = String(phone || "").replace(/\D/g, "");
  return `https://api.whatsapp.com/send?phone=${digits}&text=${encodeURIComponent(text)}`;
}
